import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'

export const StyledAccordionHeader = styled.button`
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 16px 0;

    @media ${respondAbove.md} {
        padding: 24px 0;
    }
`
